import { Component, OnInit, OnDestroy, ViewChild, AfterViewInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ReferenceCollectionModel } from '../applicant-file-service/models/reference-collection-model';
import { CustomApplicantElement } from '../job-service/service-models/CustomApplicantElement';
import { Answer } from '../applicant-service/service-models/Answer';
import { TextQuestion } from '../job-service/service-models/TextQuestion';
import { FileUploadQuestion } from '../job-service/service-models/FileUploadQuestion';
import { ModalDirective } from 'ng-uikit-pro-standard';
import { ActivatedRoute, Router } from '@angular/router';
import { ApplicantFileService } from '../applicant-file-service/applicant-file.service';
import { nullSafePath } from '../../shared/helpers/null-safe-path';

@Component({
  selector: 'app-submit-reference',
  templateUrl: './submit-reference.component.html',
  styleUrls: ['./submit-reference.component.scss']
})
export class SubmitReferenceComponent implements OnInit, OnDestroy, AfterViewInit {
  private identifier: string;
  private subscription: Subscription = new Subscription();
  private subBrandIdentifier: string;

  @ViewChild('thankYouModal')
  thankYouModal: ModalDirective;
  jobId: number;
  applicantFileId: number;
  referenceId: number;
  hasSubmitted: boolean;
  submittedPrior: boolean;
  model: ReferenceCollectionModel;
  element: CustomApplicantElement;
  
  constructor(private service: ApplicantFileService,
    private readonly route: ActivatedRoute,
    private router: Router) { }

  ngAfterViewInit(): void {
    if (this.submittedPrior) {
      this.thankYouModal.show();
    }
  }

  ngOnInit() {
    this.subscription.add(
      this.route.data.subscribe(
        data => {
          this.model = data.model;
          this.element = new CustomApplicantElement();
          this.element.intro = this.model.referenceForm.intro;
          this.element.questions = this.model.referenceForm.questions;
          this.hasSubmitted = this.model.formSubmitted;
          this.submittedPrior = this.model.formSubmitted;
        })
    );

    this.subscription.add(
      this.route.parent.params.subscribe(params => {
        this.identifier = params['identifier'];
        this.subBrandIdentifier = params['subBrandIdentifier'];
        this.jobId = params.jobId;
        this.applicantFileId = params.applicantFileId;
      })
    );

    this.subscription.add(
      this.route.params.subscribe(params => {
        this.referenceId = params.referenceId;
      })
    );
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  updateCustomApplicantElement(emittedApplicantElement: CustomApplicantElement) {
    this.element.questions = emittedApplicantElement.questions;
  }

  save() {
    const saveModel = new Array<Answer>();
    const files = new Array<File>();

    for (let i = 0; i < this.element.questions.length; i++) {
      if (this.element.questions[i].file !== undefined) {
        files.push(this.element.questions[i].file);
      }

      for (let j = 0; j < this.element.questions[i].answers.length; j++) {
        saveModel.push(this.element.questions[i].answers[j]);
      }
    }

    this.subscription.add(
      this.service.submitReferenceCollection(this.jobId, this.applicantFileId, this.model.referenceForm.id, this.referenceId,
        saveModel, files)
      .subscribe(data => {
        this.hasSubmitted = true;
        this.router.navigate(nullSafePath(
          this.identifier, this.subBrandIdentifier,
          'jobs', this.jobId,
          'applicants', this.applicantFileId,
          'reference-collections', this.model.referenceForm.id, 'thank-you'));
      })
    );
  }

  get canSave(): boolean {
    return this.element && !this.element.questions.some(x => {
      return !x.answers
        || x.answers.length === 0
        || (x.type === 'Text' && (<TextQuestion>x).answers[0].value.length === 0)
        || (x.type === 'File' && (<FileUploadQuestion>x).isValid === false);
    });
  }
}
